import { Controller } from "stimulus"

export default class extends Controller {
  static targets = []

  connect() {}

  handleAnswerClick(e) {
    e.currentTarget.classList.add("answered");

    // if correct transition to next page
    if (e.currentTarget.dataset.correct == "true") {
      setTimeout(() => {
        window.location = document.querySelector("#next-btn").href;
      }, 750);
    }
  }
}
